export function RESET_PASSWORD_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function RESET_PASSWORD_SUCCESS(state) {
  localStorage.removeItem("user");
  localStorage.removeItem("id_token");
  localStorage.removeItem("refresh_token");
  state;
  state.isLoading = false;
}
export function RESET_PASSWORD_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
